import { COLORS } from "./constants";

export const TWEETS = [
    {
        id: 1,
        tweet: `Last year, PASCO for Free SHS did cost us 
        GHS35 million`,
        time: `StatsGh. 6 hours ago`,
    },
    {
        id: 2,
        tweet: `For every GHS30 Government budgets for 
        workers of Zoomlion, only GHS9.00 is paid 
        to them`,
        time: `StatsGh. 6 hours ago`,
    },
    {
        id: 3,
        tweet: `Every GHS1000 you had on Val’s day this year is now worth GHS792 in dollar terms`,
        time: `Statsgh. 20 hours ago`,
    },
    {
        id: 4,
        tweet: `The cost incurred by accident patients in Korlebu in 2016 stood around $11 million`,
        time: `StatsGh. 20 hours ago`,
    },
    {
        id: 5,
        tweet: `With the current budget for the free SHS, the money spent on the banking sector cleanup could have fundend it for 10 years`,
        time: `Abrantie Kwaku. April 06,2022`,
    },
];

export const BANNER_DATA = [
    {
        id: 0,
        title: `Population`,
         stat: `30,832,019`,
         date: `December 2021 `,
         image: "/images/image-1.jpg",
    },
    {
        id: 1,
        title: `Unemployment Rate`,
         stat: `13.4%`,
         date: `December 2021 `,
         image: "/images/image-2.jpg",
    },
    {
        id: 2,
        title: `GDP 
        (In billion US$)​`,
         stat: `$82.02`,
         date: `February 2022`,
         image: "/images/image-3.jpg",
    },
];

export const PROCESS_DEF = `Surveys are conducted to gather the information that reflects the population’s attitudes, behaviors, opinions, and beliefs that cannot be observed directly.`;

export const PROCESS = [
    {
        selector: `01`,
        color: COLORS.yellow,
        title: `Define Survey Objectives`,
        extract: `Exactly what is it do you want to know? Is there a problem that needs solving? We focus mainly on client objectives and you are guaranteed a survey with clear result.`,
    },
    {
        selector: `02`,
        color: COLORS.green,
        title: `Prioritize Questions`,
        extract: `We carefully design questions related to your goals and objectives and what responses might ultimately help you to make more informed decisions.`,
    },
    {
        selector: `03`,
        color: COLORS.blue,
        title: `Survey Type`,
        extract: `There are several survey choices. 
        We consider carefully the best and most appropriate survey type and combine various skills which will work effectively for us to achieve the objective at hand.`,
    },
    {
        selector: `04`,
        color: COLORS.red,
        title: `Identify Target Audience`,
        extract: `Our team of experts consider where (Catchment area) survey should be conducted, who and number of respondents to be interviewed so as to achieve the best results.`,
    },
    {
        selector: `05`,
        color: COLORS.green,
        title: `Analyze Data`,
        extract: `Responses collected are then carefully inspected, modeled, and analyzed with the goal of discovering useful information to enhance the decision making process.`,
    },
];

export const SERVICES = [
    {
        id: 0,
        title: `Research / Surveys`,
        extract: `Our research team is capable of designing a research study, conduct of full evidence-based research on statistics, social and economic issues for profit and non-profit organizational bodies and students as well as individuals.`,
        open: false,
    },
    {
        id: 1,
        title: `Data Analysis`,
        extract: `
        Our well-resourced Research team make full use of the Survey softwares to deliver high quality analyses, in-depth written and tailored Reports, as well as bespoke charts, data coding and cleaning.`,
        open: false,
    },
    {
        id: 2,
        title: `Data Application Building`,
        extract: `Our Research team are experts in setting up surveys and to make the most complex ideas a reality using a range of interactive question styles to making sure questionnaire can gather useful and reliable data.`,
        open: false,
    },
    {
        id: 3,
        title: `Monitoring & Evaluation`,
        extract: `With an ambitious and committed team, our Monitoring and Evaluation services are purposeful and result-oriented with an aim of achieving the highest degree of customer satisfaction.`,
        open: false,
    },
    {
        id: 4,
        title: `Data Enumeration`,
        extract: `The manner in which data is collected, processed and analyzed directly impacts the quality of results rendered. We carefully consider what needs to be uncovered, as well as the type of methodologies needed to uncover it.`,
        open: false,
    },
];